module.exports = ".item-p-discount-msi .img-responsive{\r\n  margin-bottom: 10px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/promociones/detalle/detalle.component.css
// module id = ./src/app/components/promociones/detalle/detalle.component.css
// module chunks = main